/**
 * DisplayItem > Content object.
 *
 * @typedef {Object} Content
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {String} heading The item heading text.
 * @property {String} byline The item byline text.
 * @property {String} content The item content text.
 * @property {String} contentRendered The item content html string (same as text, but with certain words/hashtags linked to corresponding social networks etc).
 * @property {String} caption The item caption.
 * @property {String} link The link to the corresponding social network post.
 * @property {String} linkTitle Friendly text for the link.
 * @property {String} linkText Friendly text for the link (alternative used by Headlines).
 */
class Content {
  constructor(heading, byline, content, contentRendered, caption, link, linkTitle, linkText, displayedUrls) {
    this.heading = heading;
    this.byline = byline;
    this.content = content;
    this.contentRendered = contentRendered;
    this.caption = caption;
    this.link = link;
    this.linkTitle = linkTitle;
    this.linkText = linkText;
    this.displayedUrls = displayedUrls;
  }
}

export default Content;
